module.exports = __webpack_public_path__ + "static/media/bnr1.6c7b3ec6.jpg";